import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useAppMutation } from '../use-app-mutation.hook';
import { useInvalidateQueries } from '../use-invalidate-queries.hook';

export const useDelete = () => {
  const { invalidateQuery } = useInvalidateQueries(
    QueryKey.GET_EVENTS,
    QueryKey.GET_SAFES,
    QueryKey.GET_SAFE_CONVERSION,
    QueryKey.GET_EVENT_TRANSACTIONS,
    QueryKey.GET_ISSUED_SHARES,
    QueryKey.GET_SNAPSHOTS,
    QueryKey.GET_SNAPSHOT,
    QueryKey.GET_SAFE_OVERALL_STATUS,
    QueryKey.GET_SAFE_RECAP,
  );

  const { mutate: deleteSafe, isPending } = useAppMutation([QueryKey.DELETE_SAFE], {
    mutationFn: ({ companyId, safeId }: { companyId: string; safeId: string }) =>
      ApiService.delete({
        endpoint: BackendRoute.COMPANIES,
        routePath: [companyId, 'safes', safeId],
      }),
    onSuccess: () => {
      invalidateQuery();
    },
  });
  return { deleteSafe, isPending };
};
